import '../scrollytelling.css'
import './cinematic.css'

import clsx from 'clsx'

import { SceneProvider, useScrollStory } from '../engine'
import CinAi from './scenes/CinAi'
import CinCross from './scenes/CinCross'
import CinCube from './scenes/CinCube'
import CinData from './scenes/CinData'
import CinFinale from './scenes/CinFinale'
import CinIntro from './scenes/CinIntro'
import CinPhone from './scenes/CinPhone'
import CinProfile from './scenes/CinProfile'
import CinScore from './scenes/CinScore'
import CinSecurity from './scenes/CinSecurity'

/**
 * Version 2 „Cinematic“: Vollbild-Kapitel, die beim Scrollen stehen bleiben
 * (sticky) und ihre Animation über die Höhe der Section abspielen.
 * `height` ist die Scrollstrecke in vh, `tone` die Hintergrundfarbe.
 */
const SECTIONS = [
  {
    id: 'intro',
    label: 'Zwei Perspektiven',
    height: 320,
    tone: 'night',
    Scene: CinIntro
  },
  {
    id: 'stelle',
    label: 'Die Stelle',
    height: 340,
    tone: 'light',
    Scene: CinProfile
  },
  {
    id: 'spiele',
    label: 'Spiele statt Tests',
    height: 720,
    tone: 'night',
    Scene: CinPhone
  },
  {
    id: 'passung',
    label: 'Die Passung',
    height: 340,
    tone: 'light',
    Scene: CinScore
  },
  {
    id: 'glassbox',
    label: 'Glass Box',
    height: 420,
    tone: 'night',
    Scene: CinCube
  },
  {
    id: 'ki',
    label: 'KI als Erklärhilfe',
    height: 340,
    tone: 'light',
    Scene: CinAi
  },
  {
    id: 'kreuzmatching',
    label: 'Kreuzmatching',
    height: 460,
    tone: 'white',
    Scene: CinCross
  },
  {
    id: 'sicherheit',
    label: 'Sicherheit',
    height: 440,
    tone: 'night',
    Scene: CinSecurity
  },
  {
    id: 'daten',
    label: 'Daten für HR',
    height: 320,
    tone: 'light',
    Scene: CinData
  },
  {
    id: 'zusage',
    label: 'Die Zusage',
    height: 380,
    tone: 'blue',
    Scene: CinFinale
  }
]

export default function ScrollytellingV2() {
  const story = useScrollStory(SECTIONS.length, { mode: 'pin' })
  const current = SECTIONS[story.active]

  return (
    <div ref={story.storyRef} className='sty-root cin-root'>
      <div
        ref={story.progressRef}
        className={clsx('cin-bar', `cin-bar--${current.tone}`)}
      >
        <div className='cin-bar__fill' />
        <nav className='cin-bar__nav' aria-label='Kapitel'>
          {SECTIONS.map((s, i) => (
            <button
              key={s.id}
              type='button'
              className={clsx(
                'cin-bar__dot',
                i === story.active && 'is-active'
              )}
              onClick={() => story.scrollToChapter(i)}
              aria-label={s.label}
              title={s.label}
            />
          ))}
          <span className='cin-bar__label'>{current.label}</span>
        </nav>
      </div>

      {SECTIONS.map(({ id, height, tone, Scene }, i) => (
        <section
          key={id}
          ref={(el) => (story.chapterRefs.current[i] = el)}
          className={clsx('cin-section', `cin-tone--${tone}`)}
          style={{ height: `${height}vh` }}
          aria-label={SECTIONS[i].label}
        >
          <div
            ref={(el) => (story.sceneRefs.current[i] = el)}
            className='cin-sticky'
          >
            <SceneProvider index={i} subscribe={story.subscribe}>
              <Scene />
            </SceneProvider>
          </div>
        </section>
      ))}
    </div>
  )
}
